import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../components/toast/Toast';
import { useDeleteProcedures } from '../../queries/use-delete-procedures';

type ProcedureDeleteDialogProps = {
    procedureIds: string[];
    templateId: string;
    isOpen: boolean;
    onClose: () => void;
    onDelete: () => void;
};

function ProcedureDeleteConfirmDialog({ isOpen, procedureIds, templateId, onClose, onDelete }: ProcedureDeleteDialogProps): JSX.Element {
    const deleteProceduresQuery = useDeleteProcedures(templateId);

    function deleteProcedure(): void {
        deleteProceduresQuery.mutate(
            { ids: procedureIds },
            {
                onSuccess: () => {
                    onDelete();
                    toastNotification(
                        'success',
                        `${procedureIds.length} ${procedureIds.length === 1 ? 'procedure' : 'procedures'} deleted!`
                    );
                },
            }
        );
    }

    return (
        <Dialog
            title={`Delete ${procedureIds.length === 1 ? 'Procedure' : 'Procedures'}`}
            description={`Do you want to delete ${
                procedureIds.length > 1 ? `${procedureIds.length} procedures` : 'this procedure'
            }? Deleted procedures cannot be recovered.`}
            onClose={onClose}
            onPrimaryActionClick={deleteProcedure}
            onSecondaryActionClick={onClose}
            isOpen={isOpen}
            primaryAction="Delete"
            secondaryAction="Cancel"
            type="error"
            isLoading={deleteProceduresQuery.isLoading}
        />
    );
}

export default ProcedureDeleteConfirmDialog;
